import {
    CreateButton,
    DataTable,
    DateField,
    ExportButton,
    List,
    ReferenceField,
    SearchInput,
    SelectInput,
    TextField,
} from "@/components/admin";
import { Calendar, Mail, Phone } from "lucide-react";
import { useRecordContext } from "ra-core";
import { TopToolbar } from "../../layout/TopToolbar";
import "../HR.css";

const StatusBadge = () => {
  const record = useRecordContext();
  if (!record) return null;
  const s = record.status || "active";
  return (
    <div className={`status-bookmark ${s}`}>
      {s.replace("_", " ")}
    </div>
  );
};

const ContactCell = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <div className="contact-cell-wrapper">
      {record.email && (
        <span className="contact-item">
          <Mail className="w-3.5 h-3.5" />
          <span className="truncate max-w-[150px]">{record.email}</span>
        </span>
      )}
      {record.phone && (
        <span className="contact-item">
          <Phone className="w-3.5 h-3.5" />
          {record.phone}
        </span>
      )}
    </div>
  );
};

const filters = [
  <SearchInput key="q" source="q" alwaysOn />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: "active", name: "Active" },
      { id: "inactive", name: "Inactive" },
      { id: "terminated", name: "Terminated" },
      { id: "on_leave", name: "On Leave" },
    ]}
  />,
  <SelectInput
    key="employment_type"
    source="employment_type"
    label="Type"
    choices={[
      { id: "full_time", name: "Full Time" },
      { id: "part_time", name: "Part Time" },
      { id: "contract", name: "Contract" },
      { id: "intern", name: "Intern" },
    ]}
  />,
];

export const EmployeeList = () => (
  <List
    title="Employees"
    filterInHeader={true}
    actions={
      <TopToolbar className="employee-list-header">
        <ExportButton className="btn-green-action" />
        <CreateButton label="Add Employee" className="btn-green-action" />
      </TopToolbar>
    }
    filters={filters}
    sort={{ field: "name", order: "ASC" }}
    className="p-6"
  >
    <div className="employees-table-container">
      <DataTable rowClick="show" className="employees-table">
        <DataTable.Col
          source="employee_code"
          label="Code"
          className="employee-code"
        />
        <DataTable.Col source="name" label="Name" className="employee-name" />
        <DataTable.Col label="Department">
          <ReferenceField
            source="department_id"
            reference="hr_departments"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col label="Designation">
          <ReferenceField
            source="designation_id"
            reference="hr_designations"
            link={false}
          >
            <TextField source="title" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col label="Contact">
          <ContactCell />
        </DataTable.Col>
        <DataTable.Col label="Status">
          <StatusBadge />
        </DataTable.Col>
        <DataTable.Col label="Joined">
          <div className="joined-cell flex items-center gap-2">
            <Calendar className="w-3.5 h-3.5" />
            <DateField source="joining_date" />
          </div>
        </DataTable.Col>
      </DataTable>
    </div>
  </List>
);
